import {
    Box,
    Container,
    Flex,
    Highlight,
    Skeleton,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import CardsCarousel from "@/components/general/cardsCarousel";
import NewGuiaCard from "@/components/general/newGuiaCard";
import useFormatter from "@/hooks/useFormatter";

export const NewDevelops = ({ data }) => {
    const { NumberF } = useFormatter();
    const [dataOrderRandom, setDataOrderRandom] = useState([]);
    const [_cities, setCities] = useState([]);
    const [city, _setCity] = useState(null);
    const [stateIn, _setStateIn] = useState("");
    const [cityIn, _setCityIn] = useState("");

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const isGreaterThanXl = useBreakpointValue({ base: false, xl: true });

    const showSkeleton = () => {
        if (isGreaterThanXl) {
            return (
                <Flex
                    w="100%"
                    h="465px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="5"
                    bg="white"
                >
                    <Skeleton w="320px" h="100%" borderRadius="10px" />
                    <Skeleton w="320px" h="100%" borderRadius="10px" />
                    <Skeleton w="320px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanMd) {
            return (
                <Flex
                    w="100%"
                    h="465px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="5"
                    bg="white"
                >
                    <Skeleton w="320px" h="100%" borderRadius="10px" />
                    <Skeleton w="320px" h="100%" borderRadius="10px" />
                </Flex>
            );
        }
        return (
            <Flex
                w="100%"
                h="465px"
                direction="row"
                alignItems="center"
                justifyContent="center"
                gap="2"
                bg="white"
            >
                <Skeleton w="320px" h="100%" borderRadius="10px" />
            </Flex>
        );
    };

    useEffect(() => {
        if (data && data.length > 0) {
            /*Extraemos las ciudades */
            let cts = ["Zapopan", "Guadalajara"];
            data.map((dev) => {
                if (Array.isArray(dev.labels)) {
                    dev?.labels?.map((label) => {
                        if (label !== "SECONDHOMES") {
                            cts.push(label);
                        }
                    });
                }
            });
            /*Eliminamos duplicados */
            cts = [...new Set(cts)];
            setCities(cts);

            asyncOrdered(data);
        }
    }, [data]);

    async function asyncOrdered(data_) {
        await orderedData(data_);
    }

    const orderedData = (data_) => {
        let numero = 0;
        let numero_men = 0;

        const result = [];
        data_.map((item) => {
            let dev = normalizeDev(item);
            if (item.location_props.city === cityIn) {
                numero = numero_men + 1;
                numero_men = numero_men + 1;
            } else if (!item.location_props.city && item.location_props.state === stateIn) {
                numero = numero_men + 1;
                numero_men = numero_men + 1;
            } else {
                numero = Math.floor(Math.random() * (400 - (1000 - 1))) + 1000;
            }
            if (dev.development_id !== "sanvice" && dev.development_id !== "discpar") {
                result.push({
                    ...item,
                    ...dev,
                    idRandom: numero,
                });
            }
        });

        result.sort(function (a, b) {
            return a.idRandom - b.idRandom;
        });

        setDataOrderRandom(result);
    };

    useEffect(() => {
        if (city) {
            const result = data.filter((dev) => dev.labels.includes(city));
            setDataOrderRandom(city !== "x" ? result : data);
        }
    }, [city]);

    const normalizeDev = (dev) => {
        let result = {};
        return result;
    };

    return (
        <Box
            w="full"
            mx="auto"
            my={{ base: "50px", md: "0px" }}
            maxW="1800px"
            px={{ base: "0", md: "8" }}
            paddingBottom={{ base: "3", md: "10" }}
            bg="white"
        >
            <Box borderRadius="10px">
                <Text
                    fontSize={{ base: "md", md: "lg", lg: "2xl" }}
                    color="#002B49"
                    textAlign="center"
                    fontWeight="extrabold"
                    as="h2"
                >
                    Compra en línea
                </Text>
                <Text
                    fontSize={{ base: "sm", md: "md", lg: "xl" }}
                    color="#002B49"
                    textAlign="center"
                    mb="4"
                    fontWeight="400"
                    as="h3"
                >
                    <Highlight
                        query="#ElLugarParaTi"
                        styles={{ fontWeight: "500", color: "002B49" }}
                    >
                        Tu próximo hogar o inversión
                    </Highlight>
                </Text>
                <Container maxW="100%" mt={10}>
                    {(!data || data.length === 0) && showSkeleton()}
                    {data && data.length > 0 && (
                        <CardsCarousel gap={10}>
                            {dataOrderRandom?.map((item, index) => {
                                return (
                                    <NewGuiaCard
                                        key={item?.wiggot_code}
                                        id={item?.wiggot_code}
                                        title={item.name}
                                        propertyType={item.tipo}
                                        subTitle={
                                            item?.min_presale ||
                                            item?.min_lease ||
                                            item?.min_price ||
                                            item?.min_sale
                                                ? `Desde ${NumberF(item?.min_presale && item?.min_presale !== "1" ? item?.min_presale : item?.min_price && item?.min_price !== "1" ? item?.min_price : item.min_sale ? item.min_sale : item.min_lease, true, "", 2)} MXN`
                                                : ""
                                        }
                                        imageUrl={
                                            item.photo
                                                ? item.photo
                                                : "https://media.grupoguia.mx/assets/home-page/fichas/nodisponible.webp"
                                        }
                                        badgeText={`${NumberF(item.units, false, "", 0)} Propiedades`}
                                        link={`/desarrollo/${item.url_name}`}
                                        buttonText="Ver disponibilidad"
                                        referred={true}
                                        isOnlineSale={item?.online_sale_props?.status === "ACTIVE"}
                                        isKoppiActive={item?.status_koppi === "ACTIVE"}
                                        minPrice={item?.min_price}
                                    />
                                );
                            })}
                        </CardsCarousel>
                    )}
                </Container>
            </Box>
        </Box>
    );
};

export default NewDevelops;
